import React from "react";
import SendIcon from "material-ui-icons/Send";
import CloseIcon from "material-ui-icons/Close";
import { Button, TextField, Input, InputLabel } from "material-ui";

interface IReplyInputProps {
    handleSending: (submit: boolean, body?: string) => void;
}

interface IReplyInputDispatchProps {}

interface IReplyInputReduxProps {}

interface IReplyInputState {}

type ReplyInputProps = IReplyInputProps &
    IReplyInputDispatchProps &
    IReplyInputReduxProps;

class ReplyInput extends React.Component<ReplyInputProps, IReplyInputState> {
    replyInput: HTMLTextAreaElement;

    constructor(props: ReplyInputProps) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, document.body.scrollHeight);
    }

    componentWillUnmount() {}

    componentWillReceiveProps(nextProps: ReplyInputProps) {
        window.scrollTo(0, document.body.scrollHeight);
    }

    render() {
        return (
            <div
                style={{
                    paddingLeft: 8,
                    paddingRight: 8,
                    paddingTop: 8,
                    paddingBottom: 8,
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgb(233, 243, 249)",
                    borderTop: "2px solid #92c9f0",
                }}
            >
                <Input
                    id="replyInput"
                    multiline
                    rows={1}
                    rowsMax={4}
                    inputRef={(c) => (this.replyInput = c!)}
                    style={{
                        width: "calc(100% - 56px)",
                        backgroundColor: "white",
                    }}
                    inputProps={{ "aria-label": "Vastauskenttä" }}
                    classes={{
                        error: "hypo-error",
                        focused: "hypoblue",
                        disabled: "hypo-disabled",
                        root: "hypoblue",
                        underline: "hypoblue-underline",
                        input: "hypoblue",
                    }}
                />
                <Button
                    title="Vastaa"
                    variant="flat"
                    style={{
                        width: 48,
                        height: 48,
                        minWidth: 48,
                        marginLeft: 8,
                        color: "#3a649e",
                    }}
                    onClick={() => {
                        this.props.handleSending(true, this.replyInput.value);
                        this.replyInput.value = "";
                    }}
                >
                    <SendIcon />
                </Button>
            </div>
        );
    }
}

export default ReplyInput;



// WEBPACK FOOTER //
// ./src/views/messages/threadpage/components/ReplyInput.tsx